import { render } from "./CollaboratorDetail.vue?vue&type=template&id=455d7f75&scoped=true"
import script from "./CollaboratorDetail.vue?vue&type=script&lang=js"
export * from "./CollaboratorDetail.vue?vue&type=script&lang=js"

import "./CollaboratorDetail.vue?vue&type=style&index=0&id=455d7f75&lang=css"
import "./CollaboratorDetail.vue?vue&type=style&index=1&id=455d7f75&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-455d7f75"]])

export default __exports__